import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MessageDialog = ({ open, close, title, body, page }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => close()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {page ? (
          <Button
            onClick={() => navigate(`/${page}`)}
            endIcon={<ArrowForwardIcon style={{paddingBottom: 1}}/>}
          >
            {t('dialog.goto.button')} {page.charAt(0).toUpperCase() + page.slice(1)}
          </Button>
        ) : (
          <Button onClick={() => close()}>{t('dialog.gotit.button')}</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialog;
